import React from "react";
export function XBEhero2({language = 'en', children}) {
  return (
    <div className="v-l_block">


  <div className="v-l_block-out_bg v-c_bgwhite">
    {/* <div className="l_block_bg" /> */}
  </div>


  <div className="v-l_block_120-40-100-40">
    <div className="v-l_block-out_bg" />
    <div className="x_catnew_head">
      <div className="v-l_cols">

      <div className="x_catnew_title"><div className="v-t_h2 v-c_midnight">
        <h2 className="v-t_h2_start">
          {/* {language === 'en' ? 'Find ways to grow with' : 'Выберите возможность роста с '} */}
          Find ways to grow with <span className="v-c_blue">Xsolla Business Engine</span>
          </h2></div>

        <div className="v-t_b1">
          <div>The <strong>Xsolla Business Engine</strong> is your hub within Xsolla Publisher Account to drive revenue and growth, delivering the industry expertise and tech solutions that meet your company’s specific needs.
          </div>
        </div>
        </div>


        <div className="v-l_col_7z_8x v-x_form-xbe">
          <div className="x_catnew_formline x_hide--234">
            <div className="x_catnew_h">
            {language === 'en' ? 'To get started, select the details below that best describe your game.'
            : 'Выберите пункты, которые наиболее хорошо описывают вашу игру' }
            </div>
            {/* <div className="x_catnew_h2">
              With some info about your business and goals, the Xsolla
              Business Engine can help you market, sell, and grow your games
              more quickly, effectively, and in more places around the
              world.
            </div> */}
          </div>
          <div className="x_catnew_formline x_catnew_formline--last">
            {children}
            <div className="l_block_bg" />
          </div>
          <div className="x_catnew_formline hidden">
            <div className="l_line l_line--flex l_line--flex--center">
              <div className="xbe_card_cta xbe_card_cta--main">
                <div>Get started</div>
              </div>
            </div>
          </div>
          {/* <div className="x_catnew_target x_catnew_target--top-right" /> */}
        </div>
      </div>
    </div>
  </div>
</div>

  );
}
